import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'src/hooks';

const OnboardingTherapy = () => {
  const { t } = useTranslation('onboardingQuestion');

  const TherapistDetail = useAppSelector((state) => state.therapy.TherapistDetail);

  const [answers, setAnswers] = useState<{ [key: number]: any }>({});

  useEffect(() => {
    const initialAnswers = TherapistDetail.therapistAnswers.reduce(
      (acc, question) => ({
        ...acc,
        [question.questionId]: question.answers,
      }),
      {},
    );
    setAnswers(initialAnswers);
  }, [TherapistDetail.therapistAnswers]);

  const renderAnswer = (question: any) => {
    const answer = answers[question.questionId];
    if (!answer) return null;

    if (Array.isArray(answer)) {
      return (
        <div className='mt-2 flex flex-wrap gap-2'>
          {answer.map((a, index) => (
            <div
              key={index}
              className='text-sm text-black-600 font-medium border border-[#6C61B6] rounded-[20px] p-[10px] w-fit'
            >
              {a.label}
            </div>
          ))}
        </div>
      );
    }

    return (
      <div className='mt-2 text-sm text-black-600 font-medium border border-[#6C61B6] rounded-[20px] p-[10px] w-fit'>
        {answer.label}
      </div>
    );
  };

  return (
    <div className='p-6'>
      <div className='space-y-8'>
        {TherapistDetail.therapistAnswers.length > 0 && (
          <h2 className='text-primary font-normal mb-4 text-medium'>
            {t('highlighter.content1')}
            <span className='font-bold'>{t('highlighter.content2')}</span>{' '}
            {t('highlighter.content3')}
          </h2>
        )}
        {TherapistDetail.therapistAnswers.length > 0 ? (
          TherapistDetail.therapistAnswers.map((question, id) => (
            <div key={question.questionId} className='border-b pb-6'>
              <h2 className='font-semibold mb-4 text-lg'>
                {id + 1}. {question.questionText}
              </h2>

              {renderAnswer(question)}
            </div>
          ))
        ) : (
          <div className='pb-6 min-h-[50vh] items-center flex justify-center'>{t('noAnswers')}</div>
        )}
      </div>
    </div>
  );
};

export default OnboardingTherapy;
